function getTextWidth(text, font) {
  // re-use canvas object for better performance
  const canvas = getTextWidth.canvas || (getTextWidth.canvas = document.createElement("canvas"));
  const context = canvas.getContext("2d");
  // if (screen.width < 800){
  //     console.log("Choosing smaller font");
  //     // font = font * .3
  //     context.font = '4pt BlinkMacSystemFont';
  // }
  // else{
  //     context.font = '4pt BlinkMacSystemFont';
  // }
  // context.font = '6pt BlinkMacSystemFont';
  context.font = font;
  const metrics = context.measureText(text);
  return metrics.width;
}

class uploadExcelCSVCandidates {
  getFirstMatchingElementBasedonVariableInputStrings(variable_strings) {
    let column_data = Object.keys(JSON.parse(localStorage["csv_excel_data"])[0]);
    var variable_strings_filtered = column_data.filter((x) => variable_strings.some((keyword) => typeof x === "string" && typeof keyword === "string" && x.toLowerCase() === keyword.toLowerCase()));
    let variable_string_selected;
    if (variable_strings_filtered.length == 1) {
      variable_string_selected = variable_strings_filtered[0];
    } else if (variable_strings_filtered.length > 1) {
      // This variable strings section has to be revised for each variable string and the order in which column data is going to appear. Another layer of hard coding needed
      variable_string_selected = variable_strings_filtered[0];
    }
    return variable_string_selected;
  }

  async onClickButtonSubmitCSVData() {
    console.log("This got cliekced");
    // debugger;
    document.getElementById("completed_upload_file_submission").innerText = "Data importing...";
    console.log("onClickButtonSubmitCSVData::");
    // var nameColumn = document .getElementById("name_column") .getAttribute("data-selected");
    // var jobTitleColumn = document .getElementById("job_title_column") .getAttribute("data-selected");
    // var companyNameColumn = document .getElementById("company_name_column") .getAttribute("data-selected");
    // var locationColumn = document .getElementById("location_column") .getAttribute("data-selected");
    // var phoneNumberColumn = document .getElementById("phone_number_column") .getAttribute("data-selected");
    // var emailColumn = document .getElementById("email_column") .getAttribute("data-selected");
    // var linkColumn = document .getElementById("link_column") .getAttribute("data-selected");
    let nameColumn = this.getFirstMatchingElementBasedonVariableInputStrings([
      "Full Name",
      "Full_Name",
      "Applicant Name",
      "Name",
      "First and Last Name",
      "Complete Name",
      "Candidate Name",
      "Given Name",
      "Surname",
      "Personal Name",
      "Individual Name",
      "Participant Name",
      "User Name",
      "Client Name",
      "Member Name",
      "Employee Name",
      "Applicants Full Name",
      "Name of Applicant",
      "Family Name",
      "First Name, Last Name",
      "Name First and Last",
      "Registrant Name",
      "Name of Individual",
      "Name Full",
    ]);
    let jobTitleColumn = this.getFirstMatchingElementBasedonVariableInputStrings([
      "Curr. Company Designation",
      "Job Title",
      "current_exp_designation",
      "Designation",
      "Current Job Title",
      "Role",
      "Position",
      "Occupation",
      "Job Designation",
      "Work Title",
      "Professional Title",
      "Current Position",
      "Employment Title",
      "Job Role",
      "Career Title",
      "Official Title",
      "Business Title",
      "Job Specification",
      "Position Title",
      "Title",
      "Functional Role",
      "Position Designation",
      "Current Designation",
      "Occupational Title",
      "Work Designation",
      "Professional Role",
      "Employment Designation",
    ]);
    let companyNameColumn = this.getFirstMatchingElementBasedonVariableInputStrings([
      "Company Name",
      "current_exp_company",
      "Company",
      "Curr. Company name",
      "Companies",
      "Current Company",
      "Employer",
      "Employer Name",
      "CompanyName",
      "Business Name",
      "Firm Name",
      "Organization",
      "Corporation",
      "Enterprise",
      "Employing Company",
      "Parent Company",
      "Subsidiary",
      "Business Entity",
      "Workplace",
      "Employers Name",
      "Company Details",
      "Business Organization",
      "Corporate Name",
      "Affiliated Company",
      "Company Profile",
      "Employer Organization",
      "Trade Name",
    ]);
    let locationColumn = this.getFirstMatchingElementBasedonVariableInputStrings([
      "Location",
      "Location Name",
      "Loc",
      "Current City",
      "Place",
      "Site",
      "Address",
      "Area",
      "Venue",
      "Region",
      "City",
      "District",
      "Country",
      "Geographic Location",
      "Locale",
      "Position",
      "Location Area",
      "Town",
      "Province",
      "Territory",
      "Location Code",
      "Headquarters",
      "Branch Location",
      "Physical Location",
      "Location Details",
    ]);
    let phoneNumberColumn = this.getFirstMatchingElementBasedonVariableInputStrings([
      "Phone Number",
      "Mobile Number",
      "Mobile",
      "Mobile Phone",
      "Phone",
      "PhoneNumber",
      "ContactNumber",
      "Cell",
      "HomePhone",
      "WorkPhone",
      "Tel",
      "PhoneList",
      "EmergencyContact",
      "CustomerPhone",
      "ClientContact",
      "OfficeNumber",
      "DirectLine",
      "PrimaryPhone",
      "Hotline",
      "SupportNumber",
      "PersonalPhone",
      "Extension",
      "Home Phone",
      "Work Phone",
      "Phone List",
      "Emergency Contact",
      "Customer Phone",
      "Client Contact",
      "Office Number",
      "Direct Line",
      "Primary Phone",
      "Secondary Phone",
      "Fax Number",
      "Support Number",
      "Personal Phone",
    ]);
    let emailColumn = this.getFirstMatchingElementBasedonVariableInputStrings([
      [
        "Email",
        "E-mail Address",
        "Email Address",
        "E-mail",
        "Email ID",
        "Contact Email",
        "Electronic Mail",
        "Primary Email",
        "Work Email",
        "Personal Email",
        "Email Contact",
        "EmailAddress",
        "Official Email",
        "Email Info",
        "Mail Address",
        "Email Details",
        "Business Email",
        "Email Identifier",
        "Correspondence Email",
        "Email for Contact",
        "Email (Personal)",
        "Email (Work)",
        "User Email",
        "Direct Email",
        "Email Account",
      ],
    ]);
    let linkColumn = this.getFirstMatchingElementBasedonVariableInputStrings(["profile url", "linkedin url", "linkedin", "linkedin_url", "linkedin profile"]);
    let distanceFromJob = this.getFirstMatchingElementBasedonVariableInputStrings(["Distance from Current Location"]);

    console.log("These are the nameColumn", nameColumn);
    console.log("These are the jobTitleColumn", jobTitleColumn);
    console.log("These are the companyNameColumn", companyNameColumn);
    console.log("These are the locationColumn", locationColumn);
    console.log("These are the phoneNumberColumn", phoneNumberColumn);
    console.log("These are the emailColumn", emailColumn);
    console.log("These are the linkColumn", linkColumn);
    console.log("These are the distanceFromJob", distanceFromJob);

    // var data_obj = {};

    var columns_obj = {};
    columns_obj["full_name"] = nameColumn;
    columns_obj["job_title"] = jobTitleColumn;
    columns_obj["job_company_name"] = companyNameColumn;
    columns_obj["location_name"] = locationColumn;
    columns_obj["phone_number"] = phoneNumberColumn;
    columns_obj["email_address"] = emailColumn;
    columns_obj["profile_url"] = linkColumn;
    columns_obj["distance_from_job"] = distanceFromJob;

    let csv_excel_data = JSON.parse(localStorage["csv_excel_data"]);

    var requestBody = {
      job: JSON.parse(sessionStorage["current_table"]),
      csv_excel_data: csv_excel_data,
      columns_obj: columns_obj,
    };

    // var json_data = {
    // 	user_id: localStorage["user_id"],
    // 	job_id: JSON.parse(sessionStorage["current_table"])["table_id"],
    // 	job_name: JSON.parse(sessionStorage["current_table"])["table_name"],
    // 	csv_excel_data: csv_excel_data,
    // 	columns_obj: columns_obj,
    // };

    // data_obj["json_data"] = JSON.stringify(json_data);
    // Validate that all required columns are mapped
    console.log("Got her nameColumn ean::", nameColumn);
    console.log("Got her jobTitleColumn ean::", jobTitleColumn);
    if (nameColumn) {
      try {
        const response = await AjaxAPICall(eUrl.uploadProfile, eMethod.post, requestBody);
        if (response.hasOwnProperty("status") && response.status == "ok") {
          $(import_data_modal).modal("hide");
          refreshJob();
          $(get_gpt_process_for_candidates).modal("hide");
          document.getElementById("loader_gpt_process").innerHTML = "";
        }
      } catch (error) {
        $(import_data_modal).modal("hide");
        console.log(error);
      }
      // Hide the column mapping interface after processing
      document.getElementById("column_mapping_interface").style.display = "none";
    } else {
      alert("Please ensure candidate names are put before importing data.");
    }
  }

  showColumnMappingInterface(headers) {
    console.log("Setting up column mapping with these column headers:::", headers);
    // Function to create the dropdown options for each column
    function createDropdownOptions() {
      var selectOptions = '<a class="dropdown-item" href="javascript:" onclick="selectColumn(this, \'none\')">Select Column</a>';
      headers.forEach(function (columnName) {
        selectOptions += '<a class="dropdown-item" href="javascript:" onclick="selectColumn(this)">' + columnName + "</a>";
      });
      return selectOptions;
    }
    // Set the options for each column mapping select element

    document.getElementById("name_column").nextElementSibling.innerHTML = createDropdownOptions();
    document.getElementById("job_title_column").nextElementSibling.innerHTML = createDropdownOptions();
    document.getElementById("company_name_column").nextElementSibling.innerHTML = createDropdownOptions();
    document.getElementById("location_column").nextElementSibling.innerHTML = createDropdownOptions();
    document.getElementById("phone_number_column").nextElementSibling.innerHTML = createDropdownOptions();
    document.getElementById("email_column").nextElementSibling.innerHTML = createDropdownOptions();
    document.getElementById("link_column").nextElementSibling.innerHTML = createDropdownOptions();

    // Hide the column mapping interface. Not needed because we are doing it fully automated
    document.getElementById("column_mapping_interface").style.display = "none";
    // document.getElementById('pick_function_and_name_import_data_container').style.display = 'none';
  }

  estimateSizeOfJSON(jsonObj) {
    const str = JSON.stringify(jsonObj);
    return new Blob([str]).size; // Returns the size in bytes
  }

  saveDataToSessionStorage(key, data) {
    console.log("Saving data to session Storage", data, "key::", key);
    // var existingData = JSON.parse(sessionStorage.getItem('csv_excel_data')) || {};
    // existingData[key] = data;
    var column_data;
    console.log("This is the damn key:::", key);
    // I don't see where arrayOfArrays is defined, so I commented out the lines using it.
    if (key == "excel_data") {
      console.log("excel_data Data columns");
      // First element is kind of ridiculous and unnecessary
      // data = data.slice(1, data.length)
      const jsonArray = new UtilityFunctions().arrayToJSON(data);
      console.log("SIze of json::", this.estimateSizeOfJSON(JSON.stringify(jsonArray)));
      console.log("Complete size of localstoratge:", this.estimateSizeOfJSON(JSON.stringify(localStorage)));
      localStorage["hot_table_data"] = "[]";
      localStorage["csv_excel_data"] = JSON.stringify(jsonArray);
      // debugger;
      column_data = Object.keys(JSON.parse(localStorage["csv_excel_data"])[0]);
      console.log("This is the column data::", column_data);
    } else if (key == "csv_data") {
      console.log("CSV Data columns");
      localStorage["hot_table_data"] = "[]";
      localStorage["csv_excel_data"] = JSON.stringify(data);

      column_data = Object.keys(JSON.parse(localStorage["csv_excel_data"])[0]);
      console.log("This is the column data::", column_data);
      // column_data = Object.keys(arrayOfArrays[0])
    }
    console.log("Sending this damn column data::", column_data);

    new uploadExcelCSVCandidates().showColumnMappingInterface(column_data); // Assuming the first row contains column headers
  }
}


export { getTextWidth, uploadExcelCSVCandidates };
if (typeof window !== 'undefined') {
  window.getTextWidth = getTextWidth;
  window.uploadExcelCSVCandidates = uploadExcelCSVCandidates;
}
